import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import ClaimFormService from "@/core/services/ClaimFormService";

@Module
export default class ClaimFormModule extends VuexModule {
  page: any = {
    loading: true,
    data: {
      total: 0,
      data: [],
      pages: 0,
    }
  }
  entity = <any>{};

  @Action
  [Actions.LOAD_CLAIM_FORMS](filter) {
    this.context.commit(Mutations.SET_SEARCH_LOADING, true)
    ClaimFormService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_CLAIM_FORMS, {loading: false, data: res})
    }).finally(() => {
      this.context.commit(Mutations.SET_SEARCH_LOADING, false)
    })
  }

  @Action
  [Actions.LOAD_CLAIM_FORM](id) {
    ClaimFormService.get(id).then(res => {
      this.context.commit(Mutations.SET_CLAIM_FORM, res)
    })
  }

  @Mutation
  [Mutations.SET_CLAIM_FORMS](data) {
    this.page = data;
  }

  @Mutation
  [Mutations.SET_CLAIM_FORM](data) {
    this.entity = data;
  }

}